import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useTranslation } from "react-i18next";
/** The ⋯ menu: Configure widget · View data · Export (CSV or SQL) · Duplicate. */
export function MonitoringWidgetMenu(_a) {
    var widgetTitle = _a.widgetTitle, onConfigure = _a.onConfigure, onViewData = _a.onViewData, onExport = _a.onExport, onDuplicate = _a.onDuplicate;
    var t = useTranslation().t;
    var _b = useState(null), anchor = _b[0], setAnchor = _b[1];
    var choose = function (action) { return function () {
        setAnchor(null);
        action === null || action === void 0 ? void 0 : action();
    }; };
    var items = [
        {
            key: "configure",
            label: t("monitoring.widget.configure"),
            action: onConfigure,
            always: false,
        },
        { key: "viewData", label: t("monitoring.widget.viewData"), action: onViewData, always: true },
        { key: "export", label: t("monitoring.widget.export"), action: onExport, always: true },
        {
            key: "duplicate",
            label: t("monitoring.widget.duplicate"),
            action: onDuplicate,
            always: false,
        },
    ].filter(function (item) { return item.always || item.action; });
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, { size: "small", "aria-label": t("monitoring.widget.menu", { widget: widgetTitle }), "aria-haspopup": "menu", onClick: function (event) { return setAnchor(event.currentTarget); }, children: _jsx(MoreHorizIcon, { fontSize: "small" }) }), _jsx(Menu, { anchorEl: anchor, open: Boolean(anchor), onClose: function () { return setAnchor(null); }, children: items.map(function (item) { return (_jsx(MenuItem, { disabled: !item.action, onClick: choose(item.action), children: item.label }, item.key)); }) })] }));
}
